import { createApp } from "vue";
import { createHead } from "@vueuse/head";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import fadeInDirective from "./directives/fadeInDirective";
import slideInDirective from "./directives/slideInDirective";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faWhatsapp,
  faFacebookF,
  faXTwitter,
  faInstagram,
  faLinkedinIn,
  faTiktok,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCircleHalfStroke } from "@fortawesome/free-solid-svg-icons";
import clickOutsideDirective from "./directives/clickOutsideDirective";

library.add(
  faWhatsapp,
  faEnvelope,
  faFacebookF,
  faXTwitter,
  faInstagram,
  faLinkedinIn,
  faTiktok,
  faYoutube,
  faCircleHalfStroke
);

const head = createHead();
const app = createApp(App);

// Register directives
app.directive("fade-in", fadeInDirective);
app.directive("slide-in", slideInDirective);
app.directive("click-outside", clickOutsideDirective);

// Register Font Awesome
app.component("font-awesome-icon", FontAwesomeIcon);

app.use(store).use(router).use(head).mount("#app");
